import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDialog,{attrs:{"value":_vm.show,"persistent":"","content-class":"loading-dialog"}},[_c(VContainer,{attrs:{"fill-height":""}},[_c(VLayout,{attrs:{"row":"","justify-center":"","align-center":""}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":75,"width":4,"color":"primary"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }